// eslint-disable-next-line no-use-before-define
import {
  AppConstantsProvider,
  Guitar2TabsTheme,
  JobType,
  Piano2NotesTheme,
  Scan2NotesTheme,
  SET_LOCAL_DEV,
  Sing2NotesTheme,
  StudioTheme,
  Drum2NotesTheme,
  Violin2NotesTheme,
  Wind2NotesTheme,
} from '@klangio/react-shared-elements';
import { ThemeProvider } from '@mui/system';
import React from 'react';
import { createRoot } from 'react-dom/client';
import GiftCardConfiguratorWidget from './components/organisms/GiftCardConfiguratorWidget';
import PricingContainerWidget from './components/organisms/PricingContainerWidget';
import { InputContainerWidget } from './components/organisms/InputContainerWidget';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

SET_LOCAL_DEV(false);
(window as any).isViteEnv = false;
// InputContainerWidget
const rootInput = document.getElementById('root-ai2notes-input') as HTMLElement;
if (rootInput) {
  const appName = rootInput.getAttribute('app');
  (window as any).JOBTYPE = appName;
  (window as any).import = {};
  (window as any).isViteEnv = false;
  const root = createRoot(rootInput);

  if (appName === JobType.TranscribeGuitar) {
    root.render(
      <InputContainerWidget
        theme={Guitar2TabsTheme}
        jobType={JobType.TranscribeGuitar}
        baseUrl="https://guitar2tabs.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeSinging) {
    root.render(
      <InputContainerWidget
        theme={Sing2NotesTheme}
        jobType={JobType.TranscribeSinging}
        baseUrl="https://sing2notes.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeDrums) {
    root.render(
      <InputContainerWidget
        theme={Drum2NotesTheme}
        jobType={JobType.TranscribeDrums}
        baseUrl="https://drum2notes.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeStudio) {
    root.render(
      <InputContainerWidget
        theme={StudioTheme}
        jobType={JobType.TranscribeStudio}
        baseUrl="https://studio.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeScan) {
    root.render(
      <InputContainerWidget
        theme={Scan2NotesTheme}
        jobType={JobType.TranscribeScan}
        baseUrl="https://scan2notes.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeViolin) {
    root.render(
      <InputContainerWidget
        theme={Violin2NotesTheme}
        jobType={JobType.TranscribeViolin}
        baseUrl="https://violin2notes.klang.io"
      />,
    );
  } else if (appName === JobType.TranscribeWind) {
    root.render(
      <InputContainerWidget
        theme={Wind2NotesTheme}
        jobType={JobType.TranscribeWind}
        baseUrl="https://wind2notes.klang.io"
      />,
    );
  } else {
    root.render(
      <InputContainerWidget
        theme={Piano2NotesTheme}
        jobType={JobType.TranscribePiano}
        baseUrl="https://piano2notes.klang.io"
      />,
    );
  }
}

// PricingContainerWidget
const rootPricing = document.getElementById('root-ai2notes-pricing') as HTMLElement;
if (rootPricing) {
  const appName = rootPricing.getAttribute('app');
  (window as any).JOBTYPE = appName;
  const root = createRoot(rootPricing);
  if (appName === JobType.TranscribeGuitar) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Guitar2TabsTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeGuitar}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeSinging) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Sing2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeSinging}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeDrums) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Drum2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeDrums}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeStudio) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={StudioTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeStudio}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeScan) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Scan2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeScan}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeViolin) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Violin2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeViolin}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else if (appName === JobType.TranscribeWind) {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Wind2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribeWind}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  } else {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={Piano2NotesTheme}>
          <AppConstantsProvider jobType={JobType.TranscribePiano}>
            <PricingContainerWidget />
          </AppConstantsProvider>
        </ThemeProvider>
      </React.StrictMode>,
    );
  }
}

// GiftCardConfiguratorWidget
const rooftGiftCards = document.getElementById('root-ai2notes-giftcards') as HTMLElement;
if (rooftGiftCards) {
  const appName = rooftGiftCards.getAttribute('app');
  (window as any).JOBTYPE = appName;
  const root = createRoot(rooftGiftCards);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={Piano2NotesTheme}>
        <AppConstantsProvider jobType={JobType.TranscribeGuitar}>
          <GiftCardConfiguratorWidget />
        </AppConstantsProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
}

// // // BannerWidget
// const rootBanner = document.getElementById('root-ai2notes-banner') as HTMLElement;
// if (rootBanner) {
//   const appName = rootBanner.getAttribute('app');
//   (window as any).JOBTYPE = appName;
//   const root = createRoot(rootBanner);

//   if (appName === 'guitar2tabs') {
//     root.render(
//       <React.StrictMode>
//         <ThemeProvider theme={Guitar2TabsTheme}>
//           <SpringSaleBanner imgPath="https://piano2notes.klang.io" />
//         </ThemeProvider>
//       </React.StrictMode>,
//     );
//   } else if (appName === 'sing2notes') {
//     root.render(
//       <React.StrictMode>
//         <ThemeProvider theme={Sing2NotesTheme}>
//           <SpringSaleBanner imgPath="https://piano2notes.klang.io" />
//         </ThemeProvider>
//       </React.StrictMode>,
//     );
//   } else {
//     root.render(
//       <React.StrictMode>
//         <ThemeProvider theme={Piano2NotesTheme}>
//           <SpringSaleBanner imgPath="https://piano2notes.klang.io" />
//         </ThemeProvider>
//       </React.StrictMode>,
//     );
//   }
// }

// Hide and show elements based on authentication
if ((window as any).jQuery) {
  (window as any).jQuery('.auth-show').hide();
  fetch('https://ai2notes.klang.io/api/auth/cookie', {
    method: 'get',
    credentials: 'include',
  }).then((response) => response.text().then((result) => {
    if (result === '') {
      (window as any).jQuery('.auth-hide').show();
      (window as any).jQuery('.auth-show').hide();
    } else {
      (window as any).jQuery('.auth-hide').hide();
      (window as any).jQuery('.auth-show').show();
    }
  }));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
